<template>
    <div class="animated fadeIn bgV2 issueRegister">
        <b-row class="p-20 pr-4" v-if="Item && Item.issue_number">
            <b-col md="12">
                <div class="d-flex headerComponent justify-content-between align-items-end">
                    <h3 class="title">{{ Item.issue_number }}</h3>
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="12" v-bind:class="{'run-loading':Loadings.detail}">
                <gofix-tab class="mt-3" :data="tabData">
                    <template slot="gofixTab:right">
                        <gofix-button 
                            v-if="Item && Item.joblist && Item.joblist.contract && Item.joblist.contract.settings && Item.joblist.contract.settings.is_allow_issue_register_show_lift_inspection_report_button" 
                            class="mr-3" 
                            label="Create Report" 
                            outline 
                            @click="showModalReportConfig" />
                        <gofix-button 
                            v-if="Item && !Item.order_id && Item.status !== `Closed`" 
                            :disabled="!isAccess"
                            class="mr-3" 
                            label="RAISE cwo" 
                            outline 
                            @click="openModalCreateOder" />
                        <gofix-button 
                            v-if="Item && Item.status !== `Closed`" 
                            :disabled="!isAccess"
                            label="Save"
                            @click="save(false)" 
                            :loading="isAction" />
                    </template>
                    <template slot="gofixTab:basic-info">
                        <gofix-card classContent="mt-4">
                            <b-row class="mb-2">
                                <b-col md="9">
                                    <b-row>
                                        <b-col class="mb-28" md="5">
                                            <gofix-text-field label="Client Contract" oneline>
                                                {{ Item && Item.joblist && Item.joblist.contract && Item.joblist.contract.contract_name ? Item.joblist.contract.contract_name : '--' }}
                                            </gofix-text-field>
                                        </b-col>
                                        <b-col class="mb-28" md="7">
                                            <gofix-text-field  classLabel="min-width-140"  label="Priority" oneline>
                                                {{ Item && Item.sla && Item.sla.priority ? Item.sla.priority : '--' }}
                                            </gofix-text-field>
                                        </b-col>
                                        <b-col md="5">
                                            <gofix-text-field label="Date recorded" oneline>
                                                <span v-if="Item && Item.issue_register_time">{{ Item.issue_register_time | formatDatebyMoment('YYYY-MM-DD HH:mm:ss','DD.MM.YYYY HH:mm') }}</span>
                                            </gofix-text-field>
                                        </b-col>
                                        <b-col md="7">
                                            <gofix-text-field classLabel="min-width-140" label="Property / location" oneline>
                                                {{ (Item && Item.joblist && Item.joblist.location) ? Item.joblist.location : '--' }}
                                            </gofix-text-field>
                                        </b-col>
                                    </b-row>
                                </b-col>
                                <b-col md="3">
                                    <gofix-form-dropdown 
                                        :disabled="!isAccess || Item.status != `New`" 
                                        v-if="Item && Item.status != `Closed`" 
                                        label="issue status" 
                                        class="m-0" 
                                        :options="options"
                                        v-model="issueStatus" />
                                    <gofix-text-field 
                                        v-if="Item && Item.status == `Closed`" 
                                        class="mt-2" 
                                        label="Issue Status" 
                                        oneline>
                                        {{ Item && Item.status ? Item.status : '--' }}
                                    </gofix-text-field>
                                </b-col>
                            </b-row>
                        </gofix-card>
                        <gofix-card classContent="mt-4">
                            <b-row class="mb-2">
                                <b-col md="9">
                                    <b-row>
                                        <b-col class="mb-28" md="5">
                                            <gofix-text-field label="Issue Date" oneline>
                                                {{ Item && Item.created_at | formatDatebyMoment('YYYY-MM-DD HH:mm:ss','DD.MM.YYYY HH:mm') }}
                                            </gofix-text-field>
                                        </b-col>
                                        <b-col class="mb-28" md="7">
                                            <gofix-text-field  classLabel="min-width-140"  label="Issue By" oneline>
                                                {{ Item && Item.created_by_user && Item.created_by_user.name ? Item.created_by_user.name : '--' }}
                                            </gofix-text-field>
                                        </b-col>
                                        <b-col md="5">
                                            <gofix-text-field label="Close Date" oneline>
                                                <span v-if="Item && Item.issue_remark && Item.issue_remark.created_at">{{ Item.issue_remark.created_at | formatDatebyMoment('YYYY-MM-DD HH:mm:ss','DD.MM.YYYY HH:mm') }}</span>
                                            </gofix-text-field>
                                        </b-col>
                                        <b-col md="7">
                                            <gofix-text-field classLabel="min-width-140" label="Close By" oneline>
                                                <span v-if="Item && Item.issue_remark && Item.issue_remark.created_by_user && Item.issue_remark.created_by_user.name">{{ Item.issue_remark.created_by_user.name }}</span>
                                                <span v-else>--</span>
                                            </gofix-text-field>
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </b-row>
                        </gofix-card>
                        <gofix-card classContent="mt-4">
                            <b-row>
                                <b-col md="11">
                                    <b-row>
                                        <b-col md="5">
                                            <gofix-text-field class="mb-3" label="Job Reference" oneline>
                                                <router-link class="custom-link text-decoration-underline" v-if="Item && Item.joblist" target='_blank' :to="`/v2/job-list/${Item.joblist.id}`">{{Item.joblist.job_number}}</router-link>
                                            </gofix-text-field>
                                        </b-col>
                                        <b-col md="4">
                                            <gofix-text-field label="Equipment Tag" oneline>
                                                {{ Item && Item.joblist && Item.joblist.equipment && Item.joblist.equipment.tag_name ? Item.joblist.equipment.tag_name : '--' }}
                                            </gofix-text-field>
                                        </b-col>
                                        <b-col md="3">
                                            <gofix-text-field label="Service Category" oneline>
                                                {{ Item && Item.joblist && Item.joblist.service_category_abbr ? Item.joblist.service_category_abbr : '--' }}
                                            </gofix-text-field>
                                        </b-col>
                                    </b-row>
                                </b-col>
                                <b-col md="1" class="text-right pr-0">
                                    <span class="editBox position-static cursor-pointer" v-if="isAccess" @click="editInfo">
                                        <img src="img/iconPencil.png" alt width="18" height="18"/>
                                    </span>
                                </b-col>
                                <b-col md="12">
                                    <gofix-text-field class="mb-3" label="Checklist Entry" oneline>
                                        {{ showChecklistEntry }}
                                    </gofix-text-field>
                                </b-col>
                                <b-col md="12">
                                    <gofix-text-field class="mb-3"  label="Value" oneline>
                                        <template v-if="Item && Item.entry_issue_sources && Item.entry_issue_sources && Item.entry_issue_sources.source.input.data_type != 'Checkbox'">
                                            {{ Item.entry_issue_sources.source.input.value }}
                                        </template>
                                        <template v-if="Item && Item.entry_issue_sources && Item.entry_issue_sources && Item.entry_issue_sources.source.input.data_type == 'Checkbox'">
                                            {{ Item.entry_issue_sources.source.input.value == true ? 'Yes' : 'No' }}
                                        </template>
                                    </gofix-text-field>
                                </b-col>
                                <b-col md="12">
                                    <gofix-text-field class="mb-3"  label="Action" oneline>
                                        {{ Item && Item.preset_actions ? Item.preset_actions : '--' }}
                                    </gofix-text-field>
                                </b-col>
                                <b-col md="12">
                                    <gofix-text-field class="mb-3" label="Issue Description" oneline>
                                        {{ Item && Item.issue_description ? Item.issue_description : '--' }}
                                    </gofix-text-field>
                                </b-col>
                                <b-col md="12">
                                    <gofix-text-field label="photos:" oneline class="photosThumb photoIssue mt-0 pt-1">
                                        <template v-if="Item && Item.photos && Item.photos.attachments">
                                            <viewer-image :images="Item.photos.attachments">
                                                <template slot="gofixViewer:list_image" ref="viewerFinding" slot-scope="{images}">
                                                    <ul class="list-thumb">
                                                        <li v-for="(item, key) in images" v-bind:key="key">
                                                            <img v-auth-image="item.url.original" :alt="item.image_file_name" :key="item.url.original" src="img/loading.gif">
                                                        </li>
                                                    </ul>
                                                </template>
                                            </viewer-image>
                                        </template>
                                    </gofix-text-field>
                                </b-col>
                            </b-row>
                            <b-modal :no-close-on-backdrop="true" id="modal-Check-FollowUp" title="Edit Issue Register" hide-footer :centered="true" v-model="modals.info.open">
                                <b-row>
                                    <!-- <b-col cols="12" class="mb-3">
                                        <gofix-form-dropdown 
                                            :disabled="Item && Item.status != `New`"
                                            label="Issue Status" 
                                            class="m-0" 
                                            :reduce="option => option.value"
                                            :options="modals.info.optionsStatus"
                                            v-model="modals.info.data.status" />
                                    </b-col> -->
                                    <b-col cols="12" class="mb-3">
                                        <gofix-form-dropdown 
                                            label="Action" 
                                            class="m-0" 
                                            :options="presetActions"
                                            v-model="modals.info.data.preset_actions" />
                                    </b-col>
                                </b-row>
                                <b-button-group class="d-block text-right">
                                    <gofix-button label="APPLY" @click="saveInfo" :isLoading="modals.info.loading" noBorder></gofix-button>
                                </b-button-group>
                            </b-modal>
                        </gofix-card>
                        
                        <gofix-card title="Action Taken" classContent="mt-4">
                            <template slot="gofixCard:right_header">
                                <span class="editBox position-static cursor-pointer" v-if="isAccessActionTaken" @click="editActionTaken">
                                    <img src="img/iconPencil.png" alt width="18" height="18"/>
                                </span>
                            </template>
                            <b-row>
                                <b-col md="11">
                                    <b-row>
                                        <b-col md="12">
                                            <gofix-text-field class="mb-3" label="Date Rectified" oneline>
                                                {{ Item && Item.action_taken_date_rectified ? Item.action_taken_date_rectified : null | formatDatebyMoment('YYYY-MM-DD','DD.MM.YYYY') }}
                                            </gofix-text-field>
                                        </b-col>
                                        <b-col md="12">
                                            <gofix-text-field class="mb-3" label="Description" oneline>
                                                <span v-html="Item && Item.action_taken_description ? Item.action_taken_description.replaceAll('\n', '<br>') : ''"></span>
                                            </gofix-text-field>
                                        </b-col>
                                    </b-row>
                                </b-col>
                                <b-col md="12">
                                    <gofix-text-field label="photos:" oneline class="photosThumb photoIssue mt-0 pt-1">
                                        <template v-if="Item && Item.action_taken_photos">
                                            <viewer-image :images="Item.action_taken_photos">
                                                <template slot="gofixViewer:list_image" ref="viewerFinding" slot-scope="{images}">
                                                    <ul class="list-thumb">
                                                        <li v-for="(item, key) in images" v-bind:key="key">
                                                            <img v-auth-image="item.url.original" :alt="item.image_file_name" :key="item.url.original"   src="img/loading.gif">
                                                        </li>
                                                    </ul>
                                                </template>
                                            </viewer-image>
                                        </template>
                                    </gofix-text-field>
                                </b-col>
                            </b-row>
                            <b-modal :no-close-on-backdrop="true" id="modal-Check-FollowUp" title="Action Taken" hide-footer :centered="true" v-model="modals.actionTaken.open">
                                <b-row>
                                    <b-col cols="12">
                                        <gofix-form-input-date
                                            class="mb-4"
                                            v-model="actionTaken.action_taken_date_rectified"
                                            :disabled="!isEditDateActionTaken"
                                            :max-date="maxDate"
                                            label="Date"
                                            show-icon-required
                                            required>
                                        </gofix-form-input-date>
                                    </b-col>
                                    <b-col cols="12">
                                        <b-form-group label="Description " class="clear-both text-remark notFloat">
                                            <b-form-textarea 
                                                v-model="actionTaken.action_taken_description" 
                                                class="notFloat" 
                                                rows="4">
                                            </b-form-textarea>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12">
                                        <b-form-group label="photos" class="photosThumb clear-both">
                                            <ul class="list-thumb">
                                                <li v-for="(item,key) in actionTaken.action_taken_photos" v-bind:key="key">
                                                    <img v-auth-image="item.url.thumb" src="img/loading.gif" alt />
                                                    <span class="delete" @click="deleteActionTaken(item)" style="z-index: 0">
                                                        <img src="img/close.png" alt />
                                                    </span>
                                                </li>
                                            </ul>
                                            <div class="upload-btn-wrapper">
                                                <b-form-file id="fileInputMulti" v-model="imgActionTaken" :plain="true" :multiple="true"></b-form-file>
                                                <gofix-button class="m-3" label="add photo" outline></gofix-button>
                                            </div>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-button-group class="d-block text-right">
                                    <gofix-button label="APPLY" @click="save(true)" :isLoading="modals.actionTaken.loading" noBorder></gofix-button>
                                </b-button-group>
                            </b-modal>
                        </gofix-card>

                        <gofix-card classContent="mt-4">
                            <b-row>
                                <b-col md="9">
                                    <b-row>
                                        <b-col md="5">
                                            <gofix-text-field classLabel="min-width-105" label="C-WO number" oneline>
                                                <router-link class="custom-link text-decoration-underline" v-if="Item && Item.order && Item.order.order_number" target='_blank' :to="`/v2/orders/${Item.order.id}`">{{Item.order.order_number}}</router-link>
                                            </gofix-text-field>
                                        </b-col>
                                        <b-col md="7">
                                            <gofix-text-field label="C-WO status" oneline>
                                                {{ Item && Item.order && Item.order.order_status ? Item.order.order_status : '--' }}
                                            </gofix-text-field>
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </b-row>
                        </gofix-card>
                        <gofix-card classContent="mb-2 mt-4" v-if="Item && Item.status == `Closed`">
                            <b-row>
                                <b-col md="12">
                                    <gofix-text-field class="mb-3" label="remarks" oneline>
                                        {{ Item.issue_remark && Item.issue_remark.description ? Item.issue_remark.description : '' }}
                                    </gofix-text-field>
                                </b-col>
                            </b-row>
                        </gofix-card>
                    </template>
                    <template slot="gofixTab:work-findings">
                        <WorkFinding />
                    </template>
                    <template slot="gofixTab:activity-log">
                        <activities ref="activities" activityType="Issue Register" :activityId="$route.params.id"></activities>
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
        <b-modal :no-close-on-backdrop="true" id="modal-Remove" title="remove to user" hide-footer hide-header :centered="true" ref="modal-add-order">
            <div class="center">Are you sure you want to<br />create <strong>CWO</strong>?</div>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" @click="$refs['modal-add-order'].hide()">No</b-button>
                <b-button v-if="$checkRole($accessModule.order, 'create')" class="custom-btn" :disabled="isAction" @click="actionCreateOrder">
                    <b-spinner v-if="isAction" small type="grow"></b-spinner> Yes
                </b-button>
            </b-button-group>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" id="modal-Assign" title="Close Issue" hide-footer :centered="true" v-model="close_issue.open">
            <b-row>
                <b-col md="12">
                    <gofix-form-input label="Remarks" required :show-icon-required="true" v-model="close_issue.description" />
                    <b-form-group label="photos" class="photosThumb clear-both mt-0 pt-6">
                        <ul class="list-thumb">
                            <li v-for="( item, key ) in close_issue.display_photos" v-bind:key="key"><img :src="item" alt=""> <span class="delete" @click="deleteImgCloseIssue(key)"><img src="img/close.png" alt=""></span></li>
                        </ul>
                        <div class="upload-btn-wrapper">
                            <b-form-file accept="image/jpeg, image/png, image/gif" id="fileInputMulti" v-model="close_issue.files" :plain="true" :multiple="true"></b-form-file>
                            <gofix-button class="m-3" label="add photo" outline></gofix-button>
                        </div>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-button-group class="d-block text-right">
                <gofix-button label="SUBMIT" @click="saveClose" :loading="close_issue.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
        <ModalReportConfig 
            :contract_id="Item && Item.joblist && Item.joblist.client_contract_id ? Item.joblist.client_contract_id : null"
            :supplier="null"
            :eq_ids="Item && Item.joblist && Item.joblist.equipment_id ? [Item.joblist.equipment_id] : []"
            :hide_btn_report="Item && Item.status == 'Sent' ? true : false"
            v-model="modals.reportConfig.open" 
            @report="liftInspectionReport"/>
    </div>
</template>
<script>
const ViewerImage = () => import('../plugins/ViewerImage.vue')
import { mapGetters } from 'vuex'
const ModalReportConfig = () => import('./ModalReportConfig')
const WorkFinding = () => import('./WorkFinding')
const Activities = () => import("../global/Activities")
import moment from 'moment';
export default {
    name: 'issue-register-detail',
    components: {
        ViewerImage,
        ModalReportConfig,
        WorkFinding,
        Activities
    },
    data() {
        return {
            tabData: [{
                key: "basic-info",
                title: "Basic Info",
                active: true
            },
            {
                key: "work-findings",
                title: "Work Findings",
                active: false
            },
            {
                key: "activity-log",
                title: "Activity Log",
                active: false
            }],
            tabIndex: 0,
            options: [
                { label: 'Closed', value: 'Closed' },
            ],
            issueStatus: `New`,
            isAction: false,
            itemIssue: [],
            imgFollowUpAction: {
                photos: [],
                delete: []
            },
            imgFollowUp: null,
            runsheetID: null,
            checkListItem: {
                follow_up: {
                    description: '',
                    remark_type: 'JobFollowUp',
                    key_of_list: 0,
                    attachments: [],
                    id: 0
                }
            },
            close_issue: {
                open: false,
                loading: false,
                description: null,
                photos: [],
                files: null,
                display_photos: []
            },
            checklist_entry: '',
            modals:{
                reportConfig: {
                    open: false
                },
                actionTaken: {
                    open: false,
                    loading: false
                },
                info: {
                    open: false,
                    loading: false,
                    // optionsStatus: [ { label: 'Closed', value: 'Closed' } ],
                    optionsAction: [],
                    data: {
                        preset_actions: null,
                        // status: null
                    }
                }
            },
            imgActionTaken: null,
            imgActionTakenAction: {
                photos: [],
                delete: []
            },
            actionTaken: {
                action_taken_photos: null,
                action_taken_description: null,
                action_taken_date_rectified: null,
            },
            maxDate :  new Date(),
        }
    },
    computed: {
        ...mapGetters({
            Loadings: 'IssueRegisterController/Loadings',
            Item: 'IssueRegisterController/Item',
            Checklist: 'IssueRegisterController/Checklist'
        }),
        presetActions() {
            return this.Item && this.Item.joblist && this.Item.joblist.maintenance && this.Item.joblist.maintenance.preset_actions ? this.Item.joblist.maintenance.preset_actions : []
        },
        showChecklistEntry() {
            if(!this.Item) return '';
            let entry = '';
            if(this.Item.path_section_entry) entry += `${this.Item.path_section_entry}`;
            if(this.Item.checklist_entry_number) entry += ` >> ${this.Item.checklist_entry_number}`;
            if(this.Item.checklist_entry_name) entry += ` >> ${this.Item.checklist_entry_name}`;
            return entry;
        },
        isAccess() {
            if(this.Item && this.Item.status && this.Item.status == `Closed`) return false;
            if(this.$checkRole(this.$accessModule.issue_register, 'update')) {
                if(this.Item && this.Item.joblist && this.Item.joblist.job_status && this.Item.joblist.job_status == 'Completed') {
                    if(this.$checkRole(this.$accessModule.allow_editing_job_completed, 'allow_editing_job_completed')) {
                        if(this.Item.joblist.editing_of_issue_action && !this.Item.joblist.editing_of_issue_action.is_allow_edit_status) return false;
                        return true;
                    }
                    return false;
                }
                if(this.Item && this.Item.joblist && this.Item.joblist.job_status && this.Item.joblist.job_status == 'Verified') {
                    if(this.$checkRole(this.$accessModule.allow_editing_job_verified, 'allow_editing_job_verified')) {
                        if(this.Item.joblist.editing_of_issue_action && !this.Item.joblist.editing_of_issue_action.is_allow_edit_status) return false;
                        return true;
                    }
                    return false;
                }
                return true
            }
            return false;
        },
        isAccessActionTaken() {
            if(this.Item && this.Item.status && this.Item.status == `Closed`) return false;
            if(this.$checkRole(this.$accessModule.issue_register, 'update')) {
                if(this.Item && this.Item.joblist && this.Item.joblist.job_status && this.Item.joblist.job_status == 'Completed') {
                    if(this.$checkRole(this.$accessModule.allow_editing_job_completed, 'allow_editing_job_completed')) {
                        if(this.Item.joblist.editing_of_issue_action && !this.Item.joblist.editing_of_issue_action.is_allow_edit_action_taken) return false;
                        return true;
                    }
                    return false;
                }
                if(this.Item && this.Item.joblist && this.Item.joblist.job_status && this.Item.joblist.job_status == 'Verified') {
                    if(this.$checkRole(this.$accessModule.allow_editing_job_verified, 'allow_editing_job_verified')) {
                         if(this.Item.joblist.editing_of_issue_action && !this.Item.joblist.editing_of_issue_action.is_allow_edit_action_taken) return false;
                        return true;
                    }
                    return false;
                }
                return true
            }
            return false;
        },
        isEditDateActionTaken() {
            if(this.Item && this.Item.joblist && this.Item.joblist.maintenance && this.Item.joblist.maintenance.is_allow_user_to_enter_timestamp_for_issue_action_taken) return true
            return false
        }
    },
    watch: {
        imgActionTaken(val, old) {
            if (val) {
                val.forEach((file) => {
                    if (
                        file.type != "image/jpeg" &&
                        file.type != "image/png" &&
                        file.type != "image/gif"
                    ) {
                        this.$alertNotification("File format is incorrect. Please select a .jpeg, .jpg, .png, .gif file!", "warning");
                        return;
                    }
                    file.moment = moment().valueOf();
                    let data = {
                        moment: moment().valueOf(),
                        url: {
                            original: URL.createObjectURL(file),
                            medium: URL.createObjectURL(file),
                            thumb: URL.createObjectURL(file),
                        },
                    };
                    this.imgActionTakenAction.photos.push(file);
                    this.actionTaken.action_taken_photos.push(data);
                });
            }
        },
        imgFollowUp(val, old) {
            if (val) {
                val.forEach(file => {
                    if (file.type != 'image/jpeg' && file.type != 'image/png' && file.type != 'image/gif') {
                        this.$alertNotification("File format is incorrect. Please select a .jpeg, .jpg, .png, .gif file!", "warning");
                        return;
                    }
                    file.moment = moment().valueOf();
                    let data = {
                        moment: moment().valueOf(),
                        url: {
                            original: URL.createObjectURL(file),
                            medium: URL.createObjectURL(file),
                            thumb: URL.createObjectURL(file)
                        }
                    }
                    this.imgFollowUpAction.photos.push(file);
                    this.checkListItem.follow_up.attachments.push(data);
                });
            }
        },
        "close_issue.files"(val, old) {
            if (val) {
                val.forEach(file => {
                    if (file.type != 'image/jpeg' && file.type != 'image/png' && file.type != 'image/gif') {
                        this.$alertNotification("File format is incorrect. Please select a .jpeg, .jpg, .png, .gif file!", "warning");
                        return;
                    }

                    this.close_issue.photos.push(file);
                    this.close_issue.display_photos.push(URL.createObjectURL(file));
                });
            }
        },
    },
    created() {
        this.refeshPage();
    },
    methods: {
        async refeshPage() {
            this.$store.dispatch('IssueRegisterController/getItem', this.$route.params.id)
                .then(response => {
                    this.issueStatus = (this.Item && this.Item.status) ? this.Item.status : 'Registed'
                    this.runsheetID = (this.Item && this.Item.joblist) ? this.Item.joblist.id : 0
                    // let contractID = (this.Item && this.Item.joblist && this.Item.joblist.contract_id) ? this.Item.joblist.contract_id : 1
                    // let checklistID = (this.Item && this.Item.checklist_id) ? this.Item.checklist_id : 1

                    // this.checkListItem.follow_up.id = this.Item.id
                    // this.$store.dispatch('IssueRegisterController/Checklist', { contract_id: contractID, checklist_id: checklistID })
                    //     .then(response => {
                    //         this.Checklist.content_checklist.map((item, index) => {
                    //             if (item.follow_up.id == this.Item.remark_id) {
                    //                 this.checklist_entry = `${(item.section) ? item.section + ' >> ' : ''}${(item.sub_section) ? item.sub_section + ' >> ' : ''}${(item.no) ? item.no + ' >> ' : ''}${item.name ? item.name : ''}`
                    //                 this.checkListItem.follow_up.key_of_list = index
                    //             }
                    //         });

                    //         //this.checkListItem.follow_up.attachments = (this.Checklist && this.Checklist.content_checklist && this.Checklist.content_checklist[this.checkListItem.follow_up.key_of_list].follow_up) ? this.Checklist.content_checklist[this.checkListItem.follow_up.key_of_list].follow_up.attachments : []
                    //         this.checkListItem.follow_up.attachments = (this.Item && this.Item.photos) ? this.Item.photos.attachments : null
                    //         if (this.Item.issue_remark && this.Item.issue_remark.attachments) {
                    //             this.checkListItem.follow_up.attachments = this.checkListItem.follow_up.attachments.concat(this.Item.issue_remark.attachments);
                    //         }
                    //     }).catch(error => {})
                }).catch(error => {
                    return this.$router.push(`/v2/issue-register-list`);
                })
        },
        openModalCreateOder() {
            this.$refs['modal-add-order'].show();
        },
        actionCreateOrder() {
            this.isAction = true;
            this.$store.dispatch("OrderController/createOrderIssueRegister", {
                    ids: [this.Item.id],
                    sla_id: null,
                    order_type: 'Corrective'
                })
                .then(result => {
                    this.isAction = false;
                    this.$refs['modal-add-order'].hide();
                    this.refeshPage();
                    if (result.data.status == 200) {
                        return this.$alertNotification(this.$notificationV2('adding', 'order'));
                    }
                })
                .catch(error => {
                    this.isAction = false;
                    this.$refs['modal-add-order'].hide();
                    return this.$alertNotification(error.response.data.error.message, "danger");
                })
        },
        save(is_action_taken = false) {
            let request = { 
                id: this.Item.id, 
                data: {}
            }

            if (is_action_taken) {

                if(!this.actionTaken.action_taken_date_rectified) {
                    return this.$alertNotification("Date is required.", "danger");
                }
                
                if(!this.Item.action_takens[0]) {
                    return this.$alertNotification("Taken ID not exist.", "danger");
                }

                request.id = this.Item.action_takens[0].id
                request.data.photos = this.imgActionTakenAction.photos
                request.data.description = this.actionTaken.action_taken_description
                request.data.user_timestamp = null
                if(this.actionTaken.action_taken_date_rectified) {
                    const user_timestamp = moment(this.actionTaken.action_taken_date_rectified).format("YYYY-MM-DD")
                    if(!moment(user_timestamp).isSame(moment(this.Item.action_taken_date_rectified).format("YYYY-MM-DD"))) {
                        request.data.user_timestamp = `${user_timestamp} ${moment().format('HH:mm:ss')}`
                    } else {
                        request.data.user_timestamp = moment(this.Item.action_taken_date_rectified).format("YYYY-MM-DD HH:mm:ss")
                    }
                }
                this.modals.actionTaken.loading = true;
                
                this.$store.dispatch("IssueRegisterController/updateActionTaken", request)
                    .then(result => {
                        this.modals.actionTaken.loading = false;
                        this.modals.actionTaken.open = false;
                        this.refeshPage();
                        return this.$alertNotification(this.$notificationV2('editing', 'issue_register'));
                    }).catch(err => {
                        console.log(err)
                    })
                return;
            } else {
                request.status = this.Item.status
                if (this.issueStatus.value == 'Closed') {
                    this.close_issue.description = this.Item.action_taken_description;
                    if(this.Item.action_taken_photos && this.Item.action_taken_photos && this.Item.action_taken_photos.length) {
                        this.Item.action_taken_photos.map(async item => {
                            if(item.url && item.url.original) {
                                let url = item.url.original;
                                await global.axios({
                                    url: url,
                                    method: 'GET',
                                    responseType: 'blob', 
                                }).then((response) => {
                                    let blob = new Blob([response.data]);
                                    const url = window.URL.createObjectURL(blob);
                                    this.close_issue.photos.push(new File([blob], item.image_file_name));
                                    this.close_issue.display_photos.push(url);
                                })
                                .catch(error => reject(error));
                            }
                        })
                    }
                
                    this.close_issue.open = true;
                    return false
                }
            }

            this.isAction = true;
            this.$store.dispatch("IssueRegisterController/updateStatusIssueRegisteratus", request)
                .then(result => {
                    this.modals.actionTaken.open = false;
                    // this.$store.dispatch("IssueRegisterController/updateFollowUp", { 
                    //     data: this.checkListItem.follow_up, 
                    //     runsheet_id: this.runsheetID, 
                    //     action: this.imgFollowUpAction, 
                    //     isfollowUp: true,
                    //     action_taken_description: this.actionTaken.action_taken_description,
                    //     action_taken_date_rectified: moment(this.actionTaken.action_taken_date_rectified).format("YYYY-MM-DD")
                    // }) .then(result => {
                    //         this.imgFollowUpAction = {
                    //             photos: [],
                    //             delete: []
                    //         }
                    //     })
                    //     .catch(error => {
                    //         this.$alertNotification("Error", "danger");
                    //     })

                    this.isAction = false
                    this.refeshPage();
                    return this.$alertNotification(this.$notificationV2('editing', 'issue_register'));
                }).catch(err => {
                    if (err.response.data.error && err.response.data.error.message) {
                        return this.$alertNotification(err.response.data.error.message, "danger");
                    }
                })
        },
        saveClose() {
            if (!this.close_issue.description) {
                return this.$alertNotification("Remarks is required field", "danger");
            }
            if (!this.close_issue.photos.length) {
                return this.$alertNotification("Please add at least 1 image", "danger");
            }

            this.close_issue.loading = true
            this.$store.dispatch("IssueRegisterController/updateStatusIssueRegisteratus", { id: this.Item.id, data: { status: this.issueStatus.value, description: this.close_issue.description, photos: this.close_issue.photos } })
                .then(result => {
                    this.close_issue.loading = false
                    this.close_issue.open = false;
                    this.refeshPage();
                    return this.$alertNotification(this.$notificationV2('editing', 'issue_register'));
                }).catch(err => {
                    if (err.response.data.error && err.response.data.error.message) {
                        return this.$alertNotification(err.response.data.error.message, "danger");
                    }
                })
        },
        deleteImgCloseIssue(index) {
            if (this.close_issue.display_photos[index]) {
                this.$delete(this.close_issue.display_photos, index)
                this.$delete(this.close_issue.photos, index)
            }
        },
        deleteFollowUp(img) {
            if (img.moment) {
                this.checkListItem.follow_up.attachments = this.checkListItem.follow_up.attachments.filter(item => item.moment != img.moment);
                this.imgFollowUpAction.photos = this.imgFollowUpAction.photos.filter(item => item.moment != img.moment)
            } else {
                this.checkListItem.follow_up.attachments = this.checkListItem.follow_up.attachments.filter(item => item.id != img.id);
                if (this.checkListItem.follow_up) {
                    this.$store.dispatch("IssueRegisterController/deleteAttachmentsFollowUp", { ids: [img.id], key_of_list: this.checkListItem.follow_up.key_of_list })
                }
            }
        },
        showModalReportConfig() {
            this.modals.reportConfig.open = true;
        },
        liftInspectionReport(request) {
            this.modals.reportConfig.open = false;
            let nameFIle = `Lift_Inspection_Report_${moment().format('DD_MMM_YYYY')}.zip`;
            this.$store.dispatch("LiftInspectionReportController/liftInspectionReport", {
                ids: [this.Item.id],
                ...request
            })
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', nameFIle);
                document.body.appendChild(link);
                link.click();
            }).catch(err => {
                if(err.response && err.response.data.error && err.response.data.error.message) {
                    this.$alertNotification(err.response.data.error.message.error, "danger");
                }
            });
        },
        editActionTaken() {
            this.imgActionTakenAction.photos = [];
            this.actionTaken.action_taken_photos = this.Item.action_taken_photos && this.Item.action_taken_photos ? JSON.parse(JSON.stringify(this.Item.action_taken_photos)) : [];
            this.actionTaken.action_taken_description = this.Item.action_taken_description;
            this.actionTaken.action_taken_date_rectified = this.Item.action_taken_date_rectified ? moment(this.Item.action_taken_date_rectified).toDate() : null;
            this.modals.actionTaken.open = true;
        },
        deleteActionTaken(img) {
            if (img.moment) {
                this.actionTaken.action_taken_photos = this.actionTaken.action_taken_photos.filter(
                    (item) => item.moment != img.moment
                );
                this.imgActionTakenAction.photos = this.imgActionTakenAction.photos.filter(
                    (item) => item.moment != img.moment
                );
            } else {
                this.actionTaken.action_taken_photos = this.actionTaken.action_taken_photos.filter(
                    (item) => item.id != img.id
                );
                this.$store.dispatch("AttachmentController/removeAttachments", {
                    ids: [img.id]
                });
            }
        },
        async downloadFile(attachment) {
          let url = attachment.url.original;
          let params = {};
          params.url = url;
          params.image_file_name = attachment.image_file_name;

            await this.$store.dispatch("FileDownloadController/getFile", params)
          .then(response => {
          })
          .catch(err => {
              this.$alertNotification("Can not download file", "danger");
              console.log(err);
          })
        },
        editInfo() {
            // this.modals.info.data.status = this.Item.status;
            this.modals.info.data.preset_actions = this.Item.preset_actions;
            this.modals.info.open = true;
        },
        saveInfo() {
            // if (!this.modals.info.data.status) {
            //     return this.$alertNotification("Status is required field", "danger");
            // }

            // if (this.modals.info.data.status == 'Closed') {
            //     this.modals.info.open = false;
            //     this.close_issue.open = true;
            //     return false;
            // }

            let request = { 
                id: this.Item.id, 
                data: { 
                    // status: this.modals.info.data.status,
                    preset_actions: this.modals.info.data.preset_actions
                }
            }

            this.modals.info.loading = true
            this.$store.dispatch("IssueRegisterController/updateStatusIssueRegisteratus", request)
                .then(result => {
                    this.modals.info.loading = false
                    this.modals.info.open    = false;
                    this.refeshPage();
                    return this.$alertNotification(this.$notificationV2('editing', 'issue_register'));
                }).catch(err => {
                    if (err.response.data.error && err.response.data.error.message) {
                        return this.$alertNotification(err.response.data.error.message, "danger");
                    }
                })
        },
    }
}
</script>